"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LicenseProvider = void 0;

var _utils = require("../../../utils");

var _getLicenseResponse = require("./response-parsers/get-license-response");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var LicenseProvider =
/*#__PURE__*/
function () {
  function LicenseProvider(securityClient) {
    _classCallCheck(this, LicenseProvider);

    this._securityClient = securityClient;
  }

  _createClass(LicenseProvider, [{
    key: "getLicenses",
    value: function getLicenses() {
      return this._securityClient.request({
        methodName: 'GetLicenses',
        parseResponseDelegate: _getLicenseResponse.createGetLicenseResponse
      });
    }
  }, {
    key: "setLicense",
    value: function setLicense(_ref) {
      var systemId = _ref.systemId,
          systemDescription = _ref.systemDescription,
          key = _ref.key;
      return this._securityClient.request({
        methodName: 'SetLicense',
        data: {
          SystemId: systemId,
          SystemDesc: systemDescription,
          Key: key
        },
        parseResponseDelegate: function parseResponseDelegate(raw) {
          return (0, _utils.createGenericResult)(raw, 'SetLicense');
        }
      });
    }
  }]);

  return LicenseProvider;
}();

exports.LicenseProvider = LicenseProvider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/security/licensing/LicenseProvider.js
// module id = 220
// module chunks = 0